.calendar button[data-selected='true'] {
  background-color: var(--ds-background-selected, #e9f2fe);
  color: var(--ds-text-selected, #1868db);
}

.calendar button[data-selected='true']:hover {
  background-color: var(--ds-background-selected-hovered, #cfe1fd);
  color: var(--ds-text-selected, #1868db);
}

.calendar button[data-today='true'] {
  color: var(--ds-text-selected, #1868db);
}
